import * as React from "react";
import styled from "@emotion/styled";
import { Row, Col } from "reactstrap";

// Theme
import { Images } from "../../Themes";

const Container = styled.div`
  height: auto;
  margin-top: 80px;
  text-align: center;
`;

const H2 = styled.h2`
  font-weight: 700;
  font-size: 2.17em;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 40px;
`;

const Clients: React.FC<{}> = () => {
  return (
    <Container>
      <H2>
        Trusted
        <br /> by maintenance companies
      </H2>
      <Row>
        <Col xs={12} md={12} lg={12} style={{ textAlign: "center" }}>
          <img
            alt="Promaint logo"
            className="client-logo"
            src={Images.promaint}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Clients;



// WEBPACK FOOTER //
// ./src/Containers/Home/Clients.tsx